import { createSelector } from '@reduxjs/toolkit';
import moment, { type Moment } from 'moment-timezone';

export const getSchedulerDate = createSelector([state => state.scheduler], scheduler => {
  return scheduler.get('currentDate', moment()) as Moment;
});
